module.exports = __webpack_public_path__ + "OpenSans-SemiBoldItalic.130f0b2621f68c4b4296.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-SemiBoldItalic.ttf
// module id = ../../../../../src/assets/customfonts/OpenSans-SemiBoldItalic.ttf
// module chunks = styles